/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Booking_Portal_Places_FewInputs */

const en_booking_portal_places_few = /** @type {(inputs: Booking_Portal_Places_FewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} places`)
};

const pl_booking_portal_places_few = /** @type {(inputs: Booking_Portal_Places_FewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} miejsca`)
};

/**
* | output |
* | --- |
* | "{count} places" |
*
* @param {Booking_Portal_Places_FewInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_places_few = /** @type {((inputs: Booking_Portal_Places_FewInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Places_FewInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_places_few(inputs)
	return en_booking_portal_places_few(inputs)
});